/** Purelytics role helpers — CEO dashboard uses superadmin only. */
export const isAdminNav = (role) => role === 'admin' || role === 'superadmin';
export const isSuperadmin = (role) => role === 'superadmin';
